/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import { useLocalizedFromContext } from 'data/Localization';
import GradientWelcome from 'components/Icons/GradientWelcome';
import Plan from 'components/Icons/Plan';
import Tractor from 'components/Icons/Tractor';
import Header from 'components/Molecules/Header/Header';
import { errorTypes } from 'constants/index.js';

const { NO_PLANS, NO_PLOTS } = errorTypes;

const CatchError = ({ status }) => {
  const translations = {
    page_not_found: useLocalizedFromContext('page_not_found'),
    page_not_found_explenation: useLocalizedFromContext('page_not_found_explenation'),
    page_not_found_button: useLocalizedFromContext('page_not_found_button'),
    something_went_wrong: useLocalizedFromContext('something_went_wrong'),
    something_went_wrong_explenation: useLocalizedFromContext('something_went_wrong_explenation'),
    something_went_wrong_button: useLocalizedFromContext('something_went_wrong_button'),
    no_plans: useLocalizedFromContext('no_plans'),
    no_plans_explenation: useLocalizedFromContext('no_plans_explenation'),
    no_plans_button: useLocalizedFromContext('add_a_plan'),
    no_plots: useLocalizedFromContext('no_plots'),
    no_plots_explenation: useLocalizedFromContext('no_plots_explenation'),
    no_plots_button: useLocalizedFromContext('add_plot'),
  };

  const getExplenation = (paragraph, buttonLink, buttonTitle, buttonAction) => {
    let buttonProps = {
      color: 'primary',
      variant: 'outlined',
    };
    if (buttonLink) {
      buttonProps = {
        ...buttonProps,
        component: Link,
        to: buttonLink,
      };
    }
    if (buttonAction) {
      buttonProps = {
        ...buttonProps,
        onClick: buttonAction,
      };
    }
    return (
      <section className="catch_error__content__explenation">
        <p>{paragraph}</p>
        <Button {...buttonProps}>{buttonTitle}</Button>
      </section>
    );
  };

  const getTypeOfError = () => {
    switch (status) {
      case 404:
        return (
          <>
            <Header title={translations.page_not_found} showHamburger />
            <div className="catch_error__content__wrapper">
              <div className="catch_error__content__visual__wrapper">
                <h3 className="catch_error__content__visual__title catch_error__content__visual__title--field">
                  404
                </h3>
                <GradientWelcome
                  className="catch_error__content__visual__logo catch_error__content__visual__logo--field"
                  onlyField
                />
              </div>
              {getExplenation(
                translations.page_not_found_explenation,
                '/myoverview',
                translations.page_not_found_button,
              )}
            </div>
          </>
        );

      case 500:
        return (
          <>
            <Header title={translations.something_went_wrong} showHamburger />
            <div className="catch_error__content__wrapper">
              <div className="catch_error__content__visual__wrapper" style={{ marginTop: '20px' }}>
                <Tractor
                  brokenWheel
                  className="catch_error__content__visual__logo catch_error__content__visual__logo--tractor"
                />
              </div>
              {getExplenation(
                translations.something_went_wrong_explenation,
                null,
                translations.something_went_wrong_button,
                () => window.location.reload(),
              )}
            </div>
          </>
        );
      case NO_PLANS:
        return (
          <>
            <Header title={translations.no_plans} showHamburger />
            <div className="catch_error__content__wrapper">
              <div className="catch_error__content__visual__wrapper">
                <h3 className="catch_error__content__visual__title catch_error__content__visual__title--plan ">
                  ?
                </h3>
                <Plan
                  pointer={false}
                  className="catch_error__content__visual__logo catch_error__content__visual__logo--plan"
                />
              </div>
              {getExplenation(
                translations.no_plans_explenation,
                '/plan-builder/flow-select',
                translations.no_plans_button,
              )}
            </div>
          </>
        );
      case NO_PLOTS:
        return (
          <>
            <Header title={translations.no_plots} showHamburger />
            <div className="catch_error__content__wrapper">
              <div className="catch_error__content__visual__wrapper">
                <h3 className="catch_error__content__visual__title catch_error__content__visual__title--plan ">
                  ?
                </h3>
                <Plan
                  pointer={false}
                  className="catch_error__content__visual__logo catch_error__content__visual__logo--plan"
                />
              </div>
              {getExplenation(
                translations.no_plots_explenation,
                '/myplots',
                translations.no_plots_button,
              )}
            </div>
          </>
        );
      default:
        return (
          <>
            <Header title="Unknow error" showHamburger />

            <div className="catch_error__content__wrapper">
              {getExplenation(
                'Unknown error',
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea quae minima nostrum ratione numquam?',
                '/myoverview',
                'Back to home',
              )}
            </div>
          </>
        );
    }
  };

  return <div className="catch_error">{getTypeOfError()}</div>;
};

CatchError.defaultProps = {
  status: 404,
};

CatchError.propTypes = {
  status: PropTypes.any,
};

export default withRouter(CatchError);
